/**
 * @module utils/qbLinkage/shouldRun
 */

import type { IQBChangeSet, IQBLinkageHandler, TQBEvent } from './types';

export function shouldRunHandler(
  handler: IQBLinkageHandler,
  changeSet: IQBChangeSet,
): boolean {
  if (changeSet.events.size === 0) {
    return false;
  }
  if (handler.subscribe === '*') {
    return true;
  }
  return handler.subscribe.some(e => changeSet.events.has(e));
}

export function filterHandlersForChangeSet(
  handlers: IQBLinkageHandler[],
  changeSet: IQBChangeSet,
): IQBLinkageHandler[] {
  return handlers.filter(h => shouldRunHandler(h, changeSet));
}

export function hasAnyEvent(
  changeSet: IQBChangeSet,
  events: TQBEvent[],
): boolean {
  return events.some(e => changeSet.events.has(e));
}
